/* Tett kolleksjonsvisning – legg i handlekurv ved klikk på bildet
 *
 * Rutene i tett visning (snippets/dense-tile.liquid) har ingen kjøpsknapp:
 * selve bildet er knappen. Et klikk skal legge varianten i kurven og bli
 * værende på kolleksjonssiden – kunden sendes aldri videre til produktsiden.
 *
 * Ligger det flere kjøpbare varianter bak samme bilde – typisk en ring i flere
 * størrelser – åpner klikket i stedet en liten velger over bildet, og valget
 * der legges i kurven.
 *
 * Tilbakemelding kunden får – umiddelbart ved klikk, ikke først når serveren
 * har svart:
 *   1. En gull-hake legger seg over bildet med en gang
 *   2. En liten gull-brikke flyr opp til handlekurv-ikonet i headeren
 *   3. Handlekurv-varslet (cart_type: notification) åpner seg når svaret kommer
 *   4. Telleren i headeren oppdateres og spretter når brikken lander
 * Blir varen avvist av serveren, byttes haken til et kryss.
 *
 * Telleren oppdateres her uavhengig av varslet, slik at antallet stemmer selv
 * om varsel-markupen skulle feile.
 */
(function () {
  const ADD_SELECTOR = '[data-dense-add]';
  const PICKER_SELECTOR = '[data-dense-options]';
  const REMOVE_SELECTOR = '[data-dense-remove]';
  const FEEDBACK_MS = 1400;
  const FLY_MS = 650;

  // Varig markør: ruter der varianten allerede ligger i handlekurven.
  const IN_CART_CLASS = 'dense-tile--in-cart';
  let cartVariants = new Set();
  let syncTimer = null;

  const ICONS = {
    added:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    error:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    remove:
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
  };

  let liveRegion;

  function strings() {
    return window.denseTileStrings || {};
  }

  function announce(message) {
    if (!message) return;

    if (!liveRegion) {
      liveRegion = document.createElement('p');
      liveRegion.className = 'visually-hidden';
      liveRegion.setAttribute('role', 'status');
      liveRegion.setAttribute('aria-live', 'polite');
      document.body.appendChild(liveRegion);
    }

    liveRegion.textContent = message;
  }

  /* ---------------------------------------------------------------- velger */

  function panelFor(trigger) {
    const id = trigger.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function closePickers(except) {
    document.querySelectorAll(PICKER_SELECTOR + '[aria-expanded="true"]').forEach(function (trigger) {
      if (trigger === except) return;
      trigger.setAttribute('aria-expanded', 'false');
      const panel = panelFor(trigger);
      if (panel) panel.hidden = true;
    });
  }

  function togglePicker(trigger) {
    const panel = panelFor(trigger);
    if (!panel) return;

    const wasOpen = trigger.getAttribute('aria-expanded') === 'true';
    closePickers(trigger);

    trigger.setAttribute('aria-expanded', wasOpen ? 'false' : 'true');
    panel.hidden = wasOpen;

    if (!wasOpen) {
      const first = panel.querySelector('.dense-tile__option');
      if (first) first.focus();
    }
  }

  /* ------------------------------------------------------- tilbakemelding */

  function tileOf(element) {
    return element.closest('.dense-tile') || element;
  }

  function flash(tile, type) {
    const previous = tile.querySelector('.dense-tile__feedback');
    if (previous) previous.remove();

    const overlay = document.createElement('span');
    overlay.className = 'dense-tile__feedback dense-tile__feedback--' + type;
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = ICONS[type];
    tile.appendChild(overlay);

    setTimeout(function () {
      overlay.remove();
    }, FEEDBACK_MS);
  }

  /* ------------------------------------------------------------ handlekurv */

  function cartComponent() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function renderCartIcon(sections) {
    const target = document.getElementById('cart-icon-bubble');
    if (!target || !sections || !sections['cart-icon-bubble']) return;

    const parsed = new DOMParser()
      .parseFromString(sections['cart-icon-bubble'], 'text/html')
      .querySelector('.shopify-section');

    if (parsed) target.innerHTML = parsed.innerHTML;
  }

  function bumpCartCount() {
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (!bubble) return;

    bubble.classList.remove('dense-cart-bump');
    void bubble.offsetWidth; // tvinger omstart av animasjonen
    bubble.classList.add('dense-cart-bump');
  }

  /* Gull-brikken som flyr fra ruten opp til handlekurv-ikonet. Returnerer true
     når animasjonen faktisk startet, slik at telleren kan vente på landingen. */
  function flyToCart(tile) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;

    const cart = document.getElementById('cart-icon-bubble');
    if (!cart) return false;

    const fra = tile.getBoundingClientRect();
    const til = cart.getBoundingClientRect();
    if (!fra.width || !til.width) return false;

    const el = document.createElement('span');
    el.className = 'dense-fly';
    el.setAttribute('aria-hidden', 'true');
    el.innerHTML = ICONS.added;
    el.style.left = fra.left + fra.width / 2 + 'px';
    el.style.top = fra.top + fra.height / 2 + 'px';
    document.body.appendChild(el);

    const dx = til.left + til.width / 2 - (fra.left + fra.width / 2);
    const dy = til.top + til.height / 2 - (fra.top + fra.height / 2);

    void el.offsetWidth; // la startposisjonen tegnes før flyturen starter
    el.classList.add('dense-fly--i-fart');
    el.style.transform = 'translate(' + dx + 'px, ' + dy + 'px) scale(0.22)';

    setTimeout(function () {
      el.remove();
      bumpCartCount();
    }, FLY_MS + 50);

    return true;
  }

  /* ------------------------------------------------ ligger allerede i kurven
     Markøren styres av hva som faktisk er i handlekurven (/cart.js), ikke av
     hva som er blitt klikket. Da forsvinner den av seg selv når varen fjernes
     eller kurven tømmes. */

  function variantIdsIn(tile) {
    const ids = [];
    tile.querySelectorAll('[data-variant-id]').forEach(function (el) {
      const n = Number(el.dataset.variantId);
      if (n) ids.push(n);
    });
    return ids;
  }

  /* Lite kryss øverst til høyre, kun på ruter som ligger i kurven, slik at et
     feilklikk kan angres uten å åpne handlekurven. */
  function ensureRemoveButton(tile, inCart) {
    let button = tile.querySelector('.dense-tile__remove');
    if (inCart && !button) {
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'dense-tile__remove';
      button.setAttribute('data-dense-remove', '');
      button.setAttribute('aria-label', strings().remove || 'Fjern fra handlekurven');
      button.innerHTML = ICONS.remove;
      tile.appendChild(button);
    } else if (!inCart && button) {
      button.remove();
    }
  }

  function paintTiles() {
    document.querySelectorAll('.dense-tile').forEach(function (tile) {
      const inCart = variantIdsIn(tile).some(function (id) {
        return cartVariants.has(id);
      });
      tile.classList.toggle(IN_CART_CLASS, inCart);
      ensureRemoveButton(tile, inCart);
    });
  }

  /* Fjern varen(e) bak ruten fra kurven. Optimistisk: markøren og krysset
     forsvinner i det kunden klikker – serveren rydder opp etterpå, og
     scheduleSync() gjenoppretter markøren hvis kallet skulle feile. */
  async function removeFromCart(tile) {
    if (tile.getAttribute('aria-busy') === 'true') return;

    const ids = variantIdsIn(tile).filter(function (id) {
      return cartVariants.has(id);
    });
    if (!ids.length) return;

    ids.forEach(function (id) {
      cartVariants.delete(id);
    });
    paintTiles();
    announce(strings().removed || 'Fjernet fra handlekurven');

    tile.setAttribute('aria-busy', 'true');

    const updates = {};
    ids.forEach(function (id) {
      updates[id] = 0;
    });

    try {
      const response = await fetch((window.routes && window.routes.cart_update_url) || '/cart/update', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ updates: updates, sections: ['cart-icon-bubble'], sections_url: window.location.pathname }),
      });
      const result = await response.json();
      renderCartIcon(result.sections);

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'dense-tile-remove' });
      }
    } catch (error) {
      console.error('[dense-tile] Kunne ikke fjerne varen fra handlekurven:', error);
    } finally {
      tile.removeAttribute('aria-busy');
      scheduleSync();
    }
  }

  async function syncCart() {
    try {
      const base = (window.routes && window.routes.cart_url) || '/cart';
      const response = await fetch(base + '.js', { headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      cartVariants = new Set(
        (cart.items || []).map(function (item) {
          return Number(item.variant_id || item.id);
        })
      );
      paintTiles();
    } catch (error) {
      /* Markøren er kosmetisk – feiler oppslaget, lar vi rutene stå umerket. */
    }
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCart, 250);
  }

  function watchCartIcon() {
    const icon = document.getElementById('cart-icon-bubble');
    if (!icon || !window.MutationObserver) return;
    // Dawn tegner om kurv-ikonet ved enhver endring i kurven – også når en vare
    // fjernes i kurv-skuffen. Det er signalet vårt om å lese kurven på nytt.
    new MutationObserver(scheduleSync).observe(icon, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function watchGrid() {
    const grid = document.getElementById('ProductGridContainer') || document.body;
    if (!grid || !window.MutationObserver) return;
    let pending = null;
    // Nye ruter fra filtrering eller infinite scroll skal males med samme
    // kurv-status. Vi lytter bare på tilkomne noder, ikke klasse-endringene
    // paintTiles() selv gjør, så observatøren går ikke i loop.
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(paintTiles, 100);
    }).observe(grid, { childList: true, subtree: true });
  }

  function initCartState() {
    syncCart();
    watchCartIcon();
    watchGrid();
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') scheduleSync();
    });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) scheduleSync();
    });
  }

  async function addToCart(button) {
    const tile = tileOf(button);
    if (tile.getAttribute('aria-busy') === 'true') return;
    tile.setAttribute('aria-busy', 'true');

    // Umiddelbar tilbakemelding: kunden skal ikke vente på serveren for å se
    // at klikket traff. Blir varen avvist, byttes haken til kryss lenger ned.
    flash(tile, 'added');
    announce(strings().added);
    const floy = flyToCart(tile);

    const component = cartComponent();
    const sectionIds = ['cart-icon-bubble'];
    if (component && typeof component.getSectionsToRender === 'function') {
      component.getSectionsToRender().forEach(function (section) {
        if (sectionIds.indexOf(section.id) === -1) sectionIds.push(section.id);
      });
    }

    try {
      const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: sectionIds,
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();

      // Shopify svarer med status/description når noe ble avvist
      // (utsolgt, antallsregler o.l.).
      if (result.status) {
        flash(tile, 'error');
        announce(result.description || result.message || strings().soldOut);
        return;
      }

      if (component) {
        try {
          if (typeof component.setActiveElement === 'function') component.setActiveElement(button);
          component.renderContents(result);
        } catch (error) {
          console.error('[dense-tile] Handlekurv-varselet kunne ikke tegnes:', error);
        }
      }

      renderCartIcon(result.sections);
      if (!floy) bumpCartCount();

      // Merk ruten som «ligger i kurven» med en gang, og bekreft mot serveren
      // rett etterpå slik at markøren stemmer med faktisk kurv-innhold.
      cartVariants.add(Number(button.dataset.variantId));
      paintTiles();
      scheduleSync();

      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'dense-tile',
          productVariantId: button.dataset.variantId,
        });
      }
    } catch (error) {
      console.error('[dense-tile] Kunne ikke legge varen i handlekurven:', error);
      flash(tile, 'error');
      announce(strings().error);
    } finally {
      tile.removeAttribute('aria-busy');
    }
  }

  /* --------------------------------------------------------------- hendelser
     Delegert, slik at ruter som kommer inn via filtrering eller infinite
     scroll virker uten at noe må kobles opp på nytt. */

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    const removeButton = event.target.closest(REMOVE_SELECTOR);
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      removeFromCart(tileOf(removeButton));
      return;
    }

    const trigger = event.target.closest(PICKER_SELECTOR);
    if (trigger) {
      event.preventDefault();
      togglePicker(trigger);
      return;
    }

    const button = event.target.closest(ADD_SELECTOR);
    if (!button) {
      closePickers();
      return;
    }

    event.preventDefault();
    closePickers();

    if (button.dataset.available === 'false') {
      flash(tileOf(button), 'error');
      announce(strings().soldOut);
      return;
    }

    addToCart(button);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const open = document.querySelector(PICKER_SELECTOR + '[aria-expanded="true"]');
    if (!open) return;

    closePickers();
    open.focus();
  });

  initCartState();
})();
